import LogoutContainer from './container/LogoutContainer';

export default LogoutContainer;
